/* eslint-disable react/prop-types  */
import React from 'react'
import { Form, Modal, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { getInfoTooltip } from '../../utils/getInfoTooltip'
import { cloneChildComponents } from '../utils/helpers'

function GenericModalBodyError(props) {
  const { children, ...rest } = props
  const { actionLangId, status } = rest

  const INVALID_DOMAIN_PORTION =
    'The domain portion of the userPrincipalName property is invalid. You must use one of the verified domain names in your organization.'
  const INVALID_USER_EXISTS = 'Another object with the same value for property userPrincipalName already exists.'

  const INVALID_DOMAIN = 'Invalid Domain'
  const USER_ALREADY_EXISTS = 'User Already Exists'

  return (
    <Form>
      <Modal.Body>
        <Row>
          <div className="col-sm-12 col-md-12 col-lg-12">
            <span className="icon-lg font-color-danger fas fa-circle-xmark" />
            <span className="ms-3">
              <FormattedMessage id={actionLangId || 'GENERAL.ACTION_FAILED'} />
              {getInfoTooltip(
                actionLangId || 'GENERAL.ACTION_FAILED',
                status,
                'ms-3 icon fa fa-circle-question',
                'left',
                '2rem',
                'right',
              )}
            </span>
            <p className="font-color-danger" style={{ marginLeft: '2.5rem' }}>
              {/* eslint-disable no-nested-ternary */}
              {status?.StatusMessage
                ? status?.StatusMessage === INVALID_DOMAIN_PORTION
                  ? INVALID_DOMAIN
                  : status?.StatusMessage === INVALID_USER_EXISTS
                    ? USER_ALREADY_EXISTS
                    : status?.StatusMessage
                : status}
              {/* eslint-enable no-nested-ternary */}
            </p>
          </div>
        </Row>
      </Modal.Body>

      {/* Footer Child */}
      {cloneChildComponents({ ...rest }, children)}
    </Form>
  )
}

export default GenericModalBodyError
